import React from 'react';
import { Input } from 'reactstrap';

import { formatCurrencyus } from 'utils/fuctions/formatCurrencyUs';
import { parseIntFromString } from 'utils/fuctions/parseIntFromString';

const CurrencyUsMask = ({
  valueController,
  fieldName,
  value,
  shouldDisable = false
}) => {
  const handleCurrencyChange = (event) => {
    const rawValue = event.target.value;

    const isEmpty = rawValue === '';
    const lastChar = rawValue.slice(-1);
    const isLastCharNumber = !Number.isNaN(parseInt(lastChar, 10));
    const parsedValue = parseIntFromString(rawValue);

    if (isEmpty || parsedValue === 0) {
      return valueController(fieldName, '');
    }

    if (!isLastCharNumber) {
      return;
    }

    const formattedValue = formatCurrencyus(parsedValue);

    return valueController(fieldName, formattedValue);
  };

  return (
    <Input
      type="text"
      name={fieldName}
      value={value}
      placeholder="US$ 0,00"
      disabled={shouldDisable}
      onChange={handleCurrencyChange}
    />
  );
};

export default CurrencyUsMask;
